import { useEffect, useState } from "react";

import { allKeys } from "V2.0/services/keyService";

import CopyableWorkspaceId from "./CopyableWorkspaceId";
import APIKeyCreate from "./APIKeyCreate";
import APIKeysList from "./APIKeysList";
import { showErrorToast } from "V2.0/utils";

export default function APIKeys(props) {
  const { workspaceId, isViewOnly } = props;

  const [keys, setKeys] = useState({
    isLoading: true,
    data: [],
  });

  const fetchKeys = async function (workspaceId) {
    try {
      const { data } = await allKeys(workspaceId);
      setKeys({
        isLoading: false,
        data,
      });
    } catch (e) {
      showErrorToast(e, "Failed to get Api keys");
    }
  };

  useEffect(
    function () {
      if (workspaceId) {
        fetchKeys(workspaceId);
      }
    },
    [workspaceId],
  );

  return (
    <div className="flex flex-col gap-y-8 h-full">
      <div className="max-w-60">
        <CopyableWorkspaceId workspaceId={workspaceId} />
      </div>
      <div className="border rounded-lg flex flex-col h-full flex-1 min-h-0">
        <div className="flex items-center justify-between bg-gray-50 px-4 py-2 rounded-t-lg">
          <p className="text-base font-medium">API Keys</p>
          {!isViewOnly && (
            <APIKeyCreate
              workspaceId={workspaceId}
              fetchKeys={fetchKeys}
            />
          )}
        </div>
        <APIKeysList
          workspaceId={workspaceId}
          keys={keys}
          fetchKeys={fetchKeys}
          isViewOnly={isViewOnly}
        />
      </div>
    </div>
  );
}
